import { Box, Button, Flex, SimpleGrid, Spinner, Text } from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getCourses } from "redux/slices/coursesSlice";
import { setIndex } from "redux/slices/currentCourseSlice";
import { selectCurrentFormation } from "redux/slices/currentFormationSlice";
import { selectCurrentTest, setQuestions } from "redux/slices/currentTestSlice";
import { selectUserAnswersData } from "redux/slices/userAnswersSlice";
import { getProfileData } from "redux/slices/userSlice";
import { EnrollInFormation } from "types";

export default function CurrentTest() {
  const { currTest, index, questions } = useAppSelector(selectCurrentTest);
  const userAnswers = useAppSelector(selectUserAnswersData).answers;
  const dispatch = useAppDispatch();
  const user = useAppSelector(getProfileData);
  const { currFormation } = useAppSelector(selectCurrentFormation);
  const { courses } = useAppSelector(getCourses);
  const [enroll, setEnroll] = useState<EnrollInFormation>({
    id: null,
    enrollDate: null,
    formationId: null,
    isPaid: false,
    isValidCourse: false,
    testPassed: false,
    userId: user.userId,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const navigateToQuestions = (e: React.MouseEvent) => {
    dispatch(setIndex(index + 1));
    e.preventDefault();
    history.push("/test/questions");
  };
  const history = useHistory();
  const readCourse = (e: React.MouseEvent) => {
    e.preventDefault();
    console.log({ currTest });
    history.push("/course/read");
  };

  React.useEffect(() => {
    const getData = async (testId: any) => {
      try {
        const res = await axios.get(`${apiurl}/question/test/${testId}`);
        dispatch(setQuestions([...res.data]));
      } catch (error) {
        console.log(error);
      }
    };
    getData(currTest.id);
    console.log({ userAnswers });
  }, []);
  React.useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${apiurl}/enroll-in-formation?userId=${user.userId}&formationId=${currFormation.id}`
        );
        setEnroll(res.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getData();
  }, []);
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
        {loading ? (
          <Spinner />
        ) : (
          <Flex
            direction="column"
            bg={"brand.500"}
            bgSize="cover"
            py={{ base: "30px", md: "56px" }}
            px={{ base: "30px", md: "64px" }}
            borderRadius="30px"
          >
            <Text
              fontSize={{ base: "24px", md: "34px" }}
              color="white"
              mb="14px"
              maxW={{
                base: "100%",
                md: "64%",
                lg: "46%",
                xl: "70%",
                "2xl": "50%",
                "3xl": "42%",
              }}
              fontWeight="700"
              lineHeight={{ base: "32px", md: "42px" }}
            >
              {currTest.title}
            </Text>
            <Text
              fontSize="md"
              color="white"
              maxW={{
                base: "100%",
                md: "64%",
                lg: "40%",
                xl: "56%",
                "2xl": "46%",
                "3xl": "34%",
              }}
              fontWeight="500"
              mb="40px"
              lineHeight="28px"
            >
              {currTest.description}
            </Text>

            <Flex mt={5} align="center">
              <Button
                onClick={(e) => navigateToQuestions(e)}
                bg="white"
                isDisabled={enroll.testPassed ? true : false}
                color="black"
                _hover={{ bg: "whiteAlpha.900" }}
                _active={{ bg: "white" }}
                _focus={{ bg: "white" }}
                fontWeight="500"
                fontSize="14px"
                py="20px"
                px="27"
                me="38px"
              >
                Passer
              </Button>
            </Flex>
          </Flex>
        )}

        {/*<CoursesTable loading={false} tableData={useTableDataCheck().filter(course=>course.formation === currFormation.title)} />*/}
      </SimpleGrid>
    </Box>
  );
}
